module.exports = __webpack_public_path__ + "static/img/7.2bc5b6ff.png";